import React, { useEffect } from 'react';
import classNames from 'classnames';
import './styles.scss';

const Takeover = props => {

    useEffect(() => {
        if (props.isOpen) {
            window.document.body.style.overflow = 'hidden';
        } else {
            window.document.body.style.overflow = 'auto';
        }
    }, [props.isOpen]);

    return (
        <div className={classNames({
            'takeover': true,
            'takeover--default': !(props.modifiers && props.modifiers['takeover--alt']),
            'takeover--is-open': props.isOpen,
            ...props.modifiers
        })}>
            <button className="takeover__close" type="button" onClick={() => props.toggleTakeover(!props.isOpen)}><span>Stäng</span></button>
            <div className="takeover__content">
                <div className="takeover__inner">
                    {props.heading &&
                        <h1 className="takeover__heading">{props.heading}</h1>
                    }
                    {props.children}
                </div>
            </div>
            
            
        </div>
    );
};

export default Takeover;